import axios from "axios";
import {
  VENUES_LIST_REQUEST,
  VENUES_LIST_RECEIVED_REQUEST,
  VENUES_LIST_RECEIVED_ERROR,
  VENUES_LIST_UNLOAD,
  HOTEL_GROUP_SNAPSHOT_REPORT_REQUEST,
  HOTEL_GROUPS_SNAPSHOT_REPORT_RECEIVED,
  HOTEL_GROUPS_SNAPSHOT_REPORT_ERROR,
  HOTEL_GROUPS_SNAPSHOT_REPORT_UNLOAD,
  VENUE_REQUEST,
  VENUE_RECEIVED_REQUEST,
  VENUE_RECEIVED_ERROR,
  VENUE_UNLOAD,
} from "../reducers/types";
import { removeEmptySearchParams } from "../../utils";
import * as ROUTES from "../../Router/venue_routes";

const CancelToken = axios.CancelToken;

export const venuesListRequest = () => ({
  type: VENUES_LIST_REQUEST,
});

export const venuesListReceivedRequest = data => ({
  type: VENUES_LIST_RECEIVED_REQUEST,
  data,
});

export const venuesListReceivedError = error => ({
  type: VENUES_LIST_RECEIVED_ERROR,
  error,
});

export const venuesListUnload = () => ({
  type: VENUES_LIST_UNLOAD,
});

export const venueRequest = () => ({
  type: VENUE_REQUEST,
});

export const venueReceivedRequest = data => ({
  type: VENUE_RECEIVED_REQUEST,
  data,
});

export const venueReceivedError = error => ({
  type: VENUE_RECEIVED_ERROR,
  error,
});

export const venueUnload = () => ({
  type: VENUE_UNLOAD,
});

let cancelHotelGroupsSnapshotReport = () => {};

export const hotelGroupSnapshotReportRequest = () => ({
  type: HOTEL_GROUP_SNAPSHOT_REPORT_REQUEST,
});

export const hotelGroupsSnapshotReportReceived = data => ({
  type: HOTEL_GROUPS_SNAPSHOT_REPORT_RECEIVED,
  data,
});

export const hotelGroupsSnapshotReportError = error => ({
  type: HOTEL_GROUPS_SNAPSHOT_REPORT_ERROR,
  error,
});

export const hotelGroupsSnapshotReportUnload = () => ({
  type: HOTEL_GROUPS_SNAPSHOT_REPORT_UNLOAD,
});

export const fetchVenuesFromHotelGroup = (hotelGroup, token) => {
  return dispatch => {
    dispatch(venuesListRequest());
    return axios
      .get(`${window.API}/hotel-group/venues?hotelGroup=${hotelGroup}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => dispatch(venuesListReceivedRequest(response.data.data)))
      .catch(error => dispatch(venuesListReceivedError(error.data)));
  };
};

export const fetchHotelGroupsSnapshotReport = (token, queryParams = {}) => {
  queryParams = new URLSearchParams(queryParams);
  removeEmptySearchParams(queryParams);
  let queryString = queryParams.toString();
  cancelHotelGroupsSnapshotReport();
  return dispatch => {
    dispatch(hotelGroupSnapshotReportRequest());
    return axios
      .get(
        window.API +
          ROUTES.API.HOTEL_GROUPS.REPORTS.SNAPSHOT +
          "?" +
          queryString,
        {
          headers: { Authorization: `Bearer ${token}` },
          cancelToken: new CancelToken(function executor(c) {
            cancelHotelGroupsSnapshotReport = c;
          }),
        }
      )
      .then(response =>
        dispatch(hotelGroupsSnapshotReportReceived(response.data))
      )
      .catch(error => {
        if (!axios.isCancel(error)) {
          dispatch(hotelGroupsSnapshotReportError(error));
        }
      });
  };
};

export const fetchVenues = ids => {
  return dispatch => {
    dispatch(venuesListRequest());
    return axios
      .get(`${window.NODE_AS}/compare`, {
        params: {
          venues: ids,
        },
      })
      .then(response => dispatch(venuesListReceivedRequest(response.data)))
      .catch(error => dispatch(venuesListReceivedError(error.data)));
  };
};

export const fetchVenue = (id, token) => {
  return dispatch => {
    dispatch(venuesListRequest());
    return axios
      .get(window.API + ROUTES.API.HOTEL_GROUPS.VENUE.replace(":id", id), {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        dispatch(venueReceivedRequest(response.data));
      })
      .catch(error => dispatch(venueReceivedError(error.data)));
  };
};
